<div class="pre-register-container">
  <div class="pre-register-card">
    <!-- Header -->
    <div class="pre-register-header">
      <div class="brand-section">
        <img src="/vat-logo.png" alt="VAT Logo" class="vat-logo">
        <h2 class="brand-title">VAT E-Service</h2>
      </div>
      <h1 class="pre-register-title">ลงทะเบียนเบื้องต้น</h1>
      <p class="pre-register-subtitle">สร้างบัญชีผู้ใช้งานด้วยอีเมลและรหัสบัตรประชาชน</p>
    </div>

    <!-- Form -->
    <form [formGroup]="preRegisterForm" (ngSubmit)="onSubmit()" class="pre-register-form">
      <div class="form-section">
        <h3 class="section-title">
          <i class="bi bi-envelope-fill"></i>
          ข้อมูลการเข้าสู่ระบบ
        </h3>

        <!-- Email -->
        <div class="mb-4">
          <label class="form-label required">อีเมล</label>
          <div class="input-group">
            <span class="input-group-text">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
            </span>
            <input 
              type="email" 
              class="form-control" 
              formControlName="email" 
              [class.is-invalid]="hasError('email')" 
              placeholder="example@email.com"
              autocomplete="email">
          </div>
          <div class="invalid-feedback" *ngIf="hasError('email')">
            {{ getErrorMessage('email') }}
          </div>
        </div>

        <!-- CID -->
        <div class="mb-4">
          <label class="form-label required">รหัสบัตรประชาชน</label>
          <div class="input-group">
            <span class="input-group-text">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </span>
            <input 
              type="text" 
              class="form-control" 
              formControlName="cid" 
              [class.is-invalid]="hasError('cid')" 
              placeholder="กรอกรหัสบัตรประชาชน 13 หลัก"
              maxlength="13"
              autocomplete="off">
          </div>
          <div class="invalid-feedback" *ngIf="hasError('cid')">
            {{ getErrorMessage('cid') }}
          </div>
        </div>

        <!-- Info Alert -->
        <div class="alert alert-info">
          <i class="bi bi-info-circle-fill"></i>
          <div>
            <strong>หมายเหตุ:</strong> หลังจากลงทะเบียนเบื้องต้นแล้ว คุณสามารถเข้าสู่ระบบและกรอกข้อมูลส่วนตัวเพิ่มเติมได้ในภายหลัง
          </div>
        </div>
      </div>

      <!-- Form Actions -->
      <div class="form-actions">
        <button type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSubmitting">
          <i class="bi bi-x-circle"></i>
          ยกเลิก
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="isSubmitting">
          <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2"></span>
          <i *ngIf="!isSubmitting" class="bi bi-check-circle"></i>
          {{ isSubmitting ? 'กำลังลงทะเบียน...' : 'ลงทะเบียน' }}
        </button>
      </div>
    </form>

    <!-- Footer -->
    <div class="pre-register-footer">
      <p>มีบัญชีอยู่แล้ว? <a routerLink="/login" class="login-link">เข้าสู่ระบบ</a></p>
      <p class="copyright">© 2026 VAT E-Service. All rights reserved.</p>
    </div>
  </div>
</div>
